import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { ADAPTER_SVC_PARTNER_PORTAL_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';

export const useRequestDeactivateChannel = () => {
  const mutation = useMutation<{}, IErrorResponse, string>(
    REQUEST_ACTIONS.DEACTIVATE_MAGICLINE_CHANNEL,
    async (channelId: string) =>
      requestReactQuery<{}>({
        url: routeReplacer(ADAPTER_SVC_PARTNER_PORTAL_URLS.DEACTIVATE_CHANNEL, {
          channelId,
        }),
        config: { method: 'PUT' },
      }),
  );

  const { mutate } = mutation;

  const mutateWithChannelId = async (channelId: string) => mutate(channelId);
  return {
    ...mutation,
    mutate: mutateWithChannelId,
  };
};
